module.exports = __webpack_public_path__ + "static/img/branch_2.a7936a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/branch_2.jpg
// module id = MXhx
// module chunks = 0